import { render, staticRenderFns } from "./Aulas.vue?vue&type=template&id=5ca9d97b&"
import script from "./Aulas.vue?vue&type=script&lang=js&"
export * from "./Aulas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports